import ProfileInformationForm from './profile-info-form';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getUserQuery } from '../../../../api/users-api';
import { useUserSettings } from '../../../../utils/use-user-settings';
import { userPortalPagesConfig } from '../../../../shared/user-portal-pages-config';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import Divider from '@mui/material/Divider';
import SharedButton from '../../../../shared/buttons/shared-button';
import SharedIconButton from '../../../../shared/buttons/shared-icon-button';
import SharedTabHeader from '../../../../shared/shared-tab-header';
import { isFeatureEnabled } from '../../../../utils/feature-flags';
import ProfileInformationFormOld from '../profile-information-old/profile-info-form';

export default function ProfileInfoPage() {
  let { userEmail } = useParams() as { userEmail: string | undefined };
  const {
    changeLogRoles,
    directoryRoles,
    loggedInUser,
    userViewRoles,
    features,
  } = useUserSettings();
  const uiEnhancementFeaturedEnabled = isFeatureEnabled(
    'uiEnhancementPhase2',
    features
  );

  if (!userEmail) {
    userEmail = loggedInUser;
  }

  const userView = location.pathname.includes(
    userPortalPagesConfig.userPortal.link
  );

  const {
    data: user,
    isLoading: isUserLoading,
    isFetching: isUserFetching,
  } = useQuery(getUserQuery(userEmail, userView));

  if (!user || isUserLoading || isUserFetching) {
    return (
      <>
        <Box
          sx={{
            position: 'relative',
            height: '100%',
            ...(userView && { p: 2, pt: 1 }),
          }}
        >
          {userView && (
            <SharedTabHeader title="Profile Information" noDivider />
          )}

          <Stack
            flexDirection="row"
            justifyContent="flex-end"
            alignItems="center"
            gap={1}
            sx={
              !userView
                ? { position: 'absolute', top: -60, right: 0 }
                : { position: 'absolute', top: 10, right: 20 }
            }
          >
            <SharedIconButton
              variant="refresh"
              tooltipLabel="Refresh"
              disabled
            />
            <SharedButton variant="primary" disabled>
              Save
            </SharedButton>
          </Stack>

          <Box sx={{ flex: 1, height: '100%', overflowY: 'auto' }}>
            <Typography
              sx={{ fontSize: 14, fontWeight: 'bold', mb: 1, ml: 17 }}
            >
              Employee Information
            </Typography>
            <Stack
              flexDirection="row"
              flexWrap="wrap"
              gap={4}
              justifyContent="center"
              sx={{ p: 2 }}
            >
              <Skeleton variant="rounded" width={400} height={40} />
              <Skeleton variant="rounded" width={400} height={40} />
              <Skeleton variant="rounded" width={400} height={40} />
              <Box sx={{ width: 400 }} />
            </Stack>

            <Divider sx={{ my: 2 }} />
            <Typography
              sx={{ fontSize: 14, fontWeight: 'bold', mb: 1, ml: 17 }}
            >
              Primary Organization
            </Typography>
            <Stack
              flexDirection="row"
              flexWrap="wrap"
              gap={4}
              justifyContent="center"
              sx={{ p: 2 }}
            >
              {[...Array(7)].map((_, i) => (
                <Skeleton key={i} variant="rounded" width={400} height={40} />
              ))}
            </Stack>

            <Divider sx={{ my: 2 }} />
            <Typography
              sx={{ fontSize: 14, fontWeight: 'bold', mb: 1, ml: 17 }}
            >
              Google Attributes
            </Typography>
            <Stack
              sx={{
                p: 2,
                justifyContent: 'center',
                maxWidth: 1000,
                mx: 'auto',
              }}
              spacing={2}
            >
              {[...Array(10)].map((_, i) => (
                <Skeleton key={i} variant="rounded" height={40} />
              ))}
            </Stack>
          </Box>
        </Box>
      </>
    );
  } else {
    return uiEnhancementFeaturedEnabled ? (
      <ProfileInformationForm
        key={user.primaryEmail}
        user={user}
        userViewRoles={userViewRoles}
        directoryRoles={directoryRoles}
        changeLogRoles={changeLogRoles}
      />
    ) : (
      <ProfileInformationFormOld
        key={user.primaryEmail}
        user={user}
        userViewRoles={userViewRoles}
        directoryRoles={directoryRoles}
        changeLogRoles={changeLogRoles}
      />
    );
  }
}
